// extracted by mini-css-extract-plugin
module.exports = {"MenuBtns":"MenuButtonsLoader_MenuBtns__3Tavr","BtnMenu":"MenuButtonsLoader_BtnMenu__1aFo8","btnMenuAnimation":"MenuButtonsLoader_btnMenuAnimation__23DZM"};